export default "__VITE_ASSET__599a4b58__"